/* Products per row, remembered per browser.

   The choice is written straight onto the grid as a custom property, so there
   is no reflow logic to get wrong: CSS does the work. localStorage can throw
   in a locked down browser, so every access is wrapped. */
(function () {
  var KEY = 'cf_density_v1';

  function read() {
    try {
      var v = parseInt(window.localStorage.getItem(KEY), 10);
      return v >= 3 && v <= 6 ? v : null;
    } catch (e) { return null; }
  }

  function write(v) {
    try { window.localStorage.setItem(KEY, String(v)); } catch (e) {}
  }

  function start(box) {
    if (box.__cfd) return;
    box.__cfd = true;

    var range = box.querySelector('[data-cfd-range]');
    var num = box.querySelector('[data-cfd-num]');
    var grid = document.querySelector('.cfl');
    if (!range || !grid) return;

    function apply(v) {
      grid.style.setProperty('--cfl-cols', String(v));
      if (num) num.textContent = String(v);
      range.setAttribute('aria-valuetext', v + ' per row');
    }

    var saved = read();
    if (saved) range.value = String(saved);
    apply(parseInt(range.value, 10));

    range.addEventListener('input', function () {
      var v = parseInt(range.value, 10);
      apply(v);
      write(v);
    });

    box.hidden = false;
  }

  function boot() {
    var boxes = document.querySelectorAll('[data-cfd]');
    for (var i = 0; i < boxes.length; i++) start(boxes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
